export enum AgentChatStartReasonEnum {
  MANUAL = 'MANUAL',
  OTLP_ERROR = 'OTLP_ERROR',
  AGENT_REQUEST = 'AGENT_REQUEST',
}
